import { Action, State } from '../../../types/chat';

export const chatReducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'setLoading':
      return {
        ...state,
        loading: action.loading,
      };
    case 'setClientUser':
      return {
        ...state,
        apiKey: action.apiKey,
        userId: action.userId,
        userName: action.userName,
        userToken: action.userToken,
      };
    case 'setClient':
      return {
        ...state,
        client: action.client,
        feedback: { type: 'success', msg: 'Success! Connection created' },
      };
    case 'setChannel':
      return {
        ...state,
        channel: action.channel,
        feedback: { type: 'success', msg: 'Success! Channel created' },
      };
    case 'setFeedback':
      return {
        ...state,
        feedback: action.feedback,
      };
    case 'clearFeedback':
      return {
        ...state,
        feedback: undefined,
      };
    case 'setError':
      window.Sentry?.captureException(action.error);
      return {
        ...state,
        feedback: {
          type: 'error',
          msg: 'there was an error, please try again',
        },
      };
    case 'sendMessage':
      return {
        ...state,
        message: action.message,
      };
    case 'addReaction':
      return {
        ...state,
        reaction: action.reaction,
      };
    case 'startListening':
      return {
        ...state,
        listening: true,
      };
    case 'newEvent':
      return {
        ...state,
        event: action.event,
      };
    default:
      throw new Error(`Invalid action: ${action.type}`);
  }
};
